module.exports = __webpack_public_path__ + "static/farmaciasdirect-MONEI-ffd92c2f99ba912318f574d50a3d3387.png";